module.exports = __webpack_public_path__ + "media/images/login-4e928e36c40ddd36c3f7ebd61473df9b.svg";